import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { PublicationPremiereDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  PREMIERE_DEFAULT_TAB,
  PREMIERE_SHOW_TABS,
  RESOURCE,
} from '../constants';
import { PublicationPremiereShowHeader } from './PublicationPremiereShowHeader';
import { PublicationPremiereGeneralTab } from './PublicationPremiereGeneralTab';

export const PublicationPremiereShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<PublicationPremiereDetailOut>({
    resource: RESOURCE,
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle(RESOURCE, record?.title);

  const [activeTab, onTabChange] = useShowTab(
    PREMIERE_SHOW_TABS,
    PREMIERE_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <PublicationPremiereShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <PublicationPremiereGeneralTab record={record} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
